angular
  .module('app')
  .controller('MediaController', MediaController);

MediaController.$inject = ['Session', '$stateParams', 'Upload', '$state'];

function MediaController(Session, $stateParams, Upload, $state) {
  var vm = this;
  vm.filmid = $stateParams.id;
  vm.filmcat = $stateParams.categoria;
  vm.film = {};
  vm.film.video = null;

  var url = '';

  vm.uploadMedia = function () {
    if (vm.errorFile) {
      Session.alert('Due to server limitations, the maximum video size is ' + vm.errorFile.$errorParam + '. If we need the video with more quality we will let you know as soon as possible. Sorry for the inconvenience');
    } else {
      url = 'api/v2/film/' + vm.filmid + '/' + vm.filmcat;
      Session.enableLoading();
      Session.top();
      if (vm.film.video) {
        Upload.mediaDuration(vm.film.video).then(function (duration) {
          if (!Upload.isUploadInProgress()) {
            Upload.upload({
              resumeChunkSize: '2MB',
              url: url,
              data: {
                film: vm.film.video,
                state: 1,
                seccio: vm.film.categoria,
                duration: parseInt(duration, 10),
                uid: parseInt(Math.random() * 100000, 10)
              }
            })
            .then(function () {
              // Upload only screenshots
              vm.film.video = null;
              Upload.upload({
                url: url,
                data: {
                  data: vm.film,
                  state: 0
                }
              }).then(function () {
                Session.disableLoading();
                $state.go('dashboard.main');
              }, function (resp) {
                console.log('Error status: ' + resp.status);
              });
            }, function (resp) {
              console.log('Error status: ' + resp.status);
            }, function (evt) {
              var progress = parseInt(100.0 * evt.loaded / evt.total, 10);
              if (progress < 100) {
                Session.updateProgress(progress);
              } else {
                Session.updateProgress(-1);
              }
            });
          }
        });
      } else {
        vm.film.duration = 0;

        // Upload only screenshots
        Upload.upload({
          url: url,
          data: {
            data: vm.film,
            state: 0
          }
        }).then(function () {
          Session.disableLoading();
          $state.go('dashboard.main');
        }, function (resp) {
          console.log('Error status: ' + resp.status);
        });
      }
    }
  };
}
